import {styled, TextField, TextFieldProps} from "@mui/material";
import {BarekamIcon, IconVariants} from "../../icon/barekam-icon";
import React from "react";

export const OrderTextField = styled(TextField)(() => ({
    display: 'flex',
    alignItems: 'center',

    '& .MuiInputBase-root': {
        width: '100%',

        '& input' : {
            backgroundColor: 'rgb(255, 255, 255)',
        },

        '& textarea' : {
            backgroundColor: 'rgb(255, 255, 255)',
        }
    },
    '& .MuiFormLabel-asterisk': {
        color: "red"
    }
}))

export const OrderTextFieldSmall = styled(OrderTextField)(() => ({
    width: '100%',
}))

export const OrderSearch = styled((props: TextFieldProps) => (
    <TextField InputProps={{startAdornment: <BarekamIcon isLoginPage variant={IconVariants.search}/>}}
               {...props}/>
))(() => ({
    '& .MuiInputBase-root': {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        flex: '1 0 0',
        alignSelf: 'stretch',
        borderRadius: '1.25rem',
        background: 'var(--Greyscale-Secondary-GS-secondary_lighten---65, #F3F3FA)',
    },
    '& fieldSet': {
        border: 'unset'
    }
}));
